export default __webpack_public_path__ + "static/media/skoda-black-logo.dc681140.jpg";